import type { FC } from 'react';
import { InfoCircleTwoTone } from '@ant-design/icons';
import { Popover } from 'antd';
import { Spinner } from '../../atoms/Spinner';


interface SurveyBalanceProps {
  isLoading?: boolean;
  projectsLeft?: number;
  quickQuestionProjectsLeft?: number;
}

export const SurveyBalance: FC<SurveyBalanceProps> = ({
  isLoading,
  projectsLeft,
  quickQuestionProjectsLeft,
}) => {
  if (isLoading) {
    return (
      <>
        Study credits remaining
        &nbsp;
        <Spinner style={{ position: 'static', transform: 'unset' }} />
      </>
    );
  }

  return (
    <Popover
      content={(
        <>
          <p>
            Price Discovery Studies:
            {' '}
            <b>{projectsLeft}</b>
          </p>

          <p>
            Price Check Studies:
            {' '}
            <b>{quickQuestionProjectsLeft}</b>
          </p>
          {/*   TODO: Add link to purchase survey packs? */}
        </>
      )}
    >
      <span style={{ userSelect: 'none' }}>
        Study credits remaining
        &nbsp;
      </span>
      <InfoCircleTwoTone twoToneColor="#5271FF" />
    </Popover>
  );
};
